import { Component, OnInit, TemplateRef, ViewChild, HostBinding, Input, ViewContainerRef, ComponentRef, Injector, ChangeDetectorRef, Optional, Inject, LOCALE_ID, EventEmitter } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { IFormFormatConfigComponent } from "@gsp-wf/biz-process-api";
import { Observable, of, forkJoin, Subject } from 'rxjs';
import { FormFormat, FormFieldData, FormField } from '../entities/form-format';
import { FormFormatConfig, FormButtonConfig, FormFieldConfig } from '../entities/form-format-config';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ProcessDeUtil } from '../../../domain/process-de-util';
import { MessagerService } from '@farris/ui-messager';
import { NotifyService } from '@farris/ui-notify';
import { PickedResult, ServerSideToken, LookupGridComponent } from '@farris/ui-lookup';
import { switchMap, catchError } from 'rxjs/operators';
import { FormOperationConfigComponent } from '../form-operation-config/form-operation-config.component';
import { TreeTableComponent } from '@farris/ui-treetable';
import { FormFormatType } from '../entities/form-format-type';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { FormMethodConfig } from '../entities/form-method-config';

declare var System: any;

@Component({
  selector: 'lib-form-format-config',
  templateUrl: './form-format-config.component.html',
  styleUrls: ['./form-format-config.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class FormFormatConfigComponent implements OnInit, IFormFormatConfigComponent {

  @ViewChild('btnEnable') btnEnable: TemplateRef<any>;
  @ViewChild('btnDisabled') btnDisabled: TemplateRef<any>;
  @ViewChild('btnHidden') btnHidden: TemplateRef<any>;
  @ViewChild('fieldEditable') fieldEditable: TemplateRef<any>;
  @ViewChild('fieldReadonly') fieldReadonly: TemplateRef<any>;
  @ViewChild('fieldHidden') fieldHidden: TemplateRef<any>;
  @ViewChild('fieldRequired') fieldRequired: TemplateRef<any>;

  @ViewChild('btnGrid') btnGrid: DatagridComponent;
  @ViewChild('fieldTree') fieldTree: TreeTableComponent;
  @ViewChild(FormOperationConfigComponent) operationConfig: FormOperationConfigComponent;

  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  private extendComponentRef: ComponentRef<any>;

  config: FormFormatConfig = new FormFormatConfig();
  formFormat: FormFormat = new FormFormat();
  formFormatType: FormFormatType;
  loaded = new EventEmitter();


  state: 'new' | 'edit' = 'edit';

  @Input() showMethodTab = true;

  private _formFormatId: string;
  set formFormatId(v: string) {
    this._formFormatId = v;
    this.config.formFormatId = v;
  }

  get formFormatId() {
    return this._formFormatId;
  }

  private _formatConfigId: string;
  set formatConfigId(v: string) {
    this._formatConfigId = v;
    if (!v) {
      this.state = 'new';
    }
  }
  get formatConfigId() {
    return this._formatConfigId;
  }

  buttonCols = [];
  buttonConfigs = new Array();

  fieldCols = [];
  fieldConfigs = new Array();

  formatFieldList: Array<FormField> = new Array();

  showExtendTab = false;

  searchFields: { label: string, value: string }[];

  constructor(
    private http: HttpService,
    private message: MessagerService,
    private notify: NotifyService,
    private injector: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    let serchFields = {
      label : this.localePipe.transform('component.executeForms.fieldName'),
      value : 'fieldName'
    };
    if(this.searchFields) {
      if(!this.searchFields.some(x => x.value === serchFields.value)) {
        this.searchFields = this.searchFields.concat(serchFields);
      }
    }else {
      this.searchFields = [];
      this.searchFields = this.searchFields.concat(serchFields);
    }

   }

  ngOnInit() {
    this.buttonCols = [
      { field: 'buttonName', width: 100, title: this.localePipe.transform('component.executeForms.buttonName'), filter: true },
      // { field: 'buttonId', width: 100, title: '按钮标识' },
      {
        title: this.localePipe.transform('component.executeForms.enable'),
        field: 'enable',
        width: 80,
        template: this.btnEnable,
        align: 'center',
        hAlign: 'center'
      },
      {
        title: this.localePipe.transform('component.executeForms.disabled'),
        field: 'disabled',
        width: 80,
        template: this.btnDisabled,
        align: 'center',
        hAlign: 'center'
      },
      {
        title: this.localePipe.transform('component.executeForms.hidden'),
        field: 'hidden',
        width: 80,
        template: this.btnHidden,
        align: 'center',
        hAlign: 'center'
      }];
    this.fieldCols = [
      { field: 'fieldName', width: 100, title: this.localePipe.transform('component.executeForms.fieldName')},
      // { field: 'fieldId', width: 100, title: '字段标识' },
      {
        title: this.localePipe.transform('component.executeForms.editable'),
        field: 'editable',
        width: 80,
        template: this.fieldEditable,
        align: 'center',
        hAlign: 'center'
      },
      {
        title: this.localePipe.transform('component.executeForms.readonly'),
        field: 'readonly',
        width: 80,
        template: this.fieldReadonly,
        align: 'center',
        hAlign: 'center'
      },
      {
        title: this.localePipe.transform('component.executeForms.hidden'),
        field: 'hidden',
        width: 80,
        template: this.fieldHidden,
        align: 'center',
        hAlign: 'center'
      },
      {
        title: this.localePipe.transform('component.executeForms.required'),
        field: 'required',
        width: 80,
        template: this.fieldRequired,
        align: 'center',
        hAlign: 'center'
      }];
    this.getConfig().subscribe(config => {
      this.getFormMethods().subscribe(formMethods => {
        if(this.fieldConfigs && this.hasRequired(this.fieldConfigs)) {
          if(config){
            if(formMethods) {
              formMethods.forEach(data => {
                if(data.method === 'wf-required-verification') {
                  if(!this.operationConfig.operations) {
                    const operation = new FormMethodConfig();                    
                    operation.formFormatConfigId = this.config.id;
                    operation.method = data.method;
                    operation.sortOrder = data.sortOrder;
                    operation.methodParameters = data.methodParameters;
                    this.operationConfig.operations = [];
                    this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
                  }else if(!this.operationConfig.operations.some(formMethod => formMethod.method === 'wf-required-verification')) {
                    const operation = new FormMethodConfig();
                    operation.formFormatConfigId = this.config.id;
                    operation.method = data.method;
                    operation.sortOrder = data.sortOrder;
                    operation.methodParameters = data.methodParameters;
                    this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
                  }
                }
              })
            }
          }
        }else {
          if(this.operationConfig.operations) {
            this.operationConfig.operations = this.operationConfig.operations.filter(formMethod => formMethod.method != 'wf-required-verification');
          }
        }
      });
    });
  }

  submit(): Observable<any> {
    const subject = new Subject<any>();
    this.validator().subscribe(re => {
      if (re) {
        this.setBtnAndFieldConfigs();
        if (this.extendComponentRef) {
          this.extendComponentRef.instance.submit().subscribe(configId => {
            if(this.extendComponentRef.instance.formExtendConfigs){
              this.config.formExtendConfigs = this.extendComponentRef.instance.formExtendConfigs;
            }
            if (configId) {
              this.config.id = configId;
              this.saveConfig(this.config).subscribe(re => {
                subject.next({ result: true, configId: this.config.id });
              }, err => {
                this.message.error(this.localePipe.transform('component.executeForms.saveFail'));
                subject.next({ result: false, configId: this.config.id });
              });
            } else {
              if (this.state === 'new' &&
                this.config.formButtonConfigs.length === 0 &&
                this.config.formFieldConfigs.length === 0 &&
                this.operationConfig.operations.length === 0
              ) {
                setTimeout(() => {
                  subject.next({ result: true, configId: null });
                }, 10);
              } else {
                this.saveConfig(this.config).subscribe(re => {
                  subject.next({ result: true, configId: this.config.id });
                }, err => {
                  this.message.error(this.localePipe.transform('component.executeForms.saveFail'));
                  subject.next({ result: false, configId: this.config.id });
                });
              }
            }
          })
        } else {
          if (this.state === 'new' &&
          this.config.formButtonConfigs.length === 0 &&
          this.config.formFieldConfigs.length === 0 &&
          this.operationConfig.operations.length === 0
          ) {
            setTimeout(() => {
              subject.next({ result: true, configId: null });
            }, 10);
          } else {
            this.saveConfig(this.config).subscribe(re => {
              subject.next({ result: true, configId: this.config.id });
            }, err => {
              this.message.error(this.localePipe.transform('component.executeForms.saveFail'));
              subject.next({ result: false, configId: this.config.id });
            });
          }
        }
      } else {
        setTimeout(() => {
          subject.next({ result: false})
        }, 10);
      }
    })
    return subject.asObservable();
  }



  searchField(data) {
    data.field = 'fieldName';
    let searchData = {
      field : 'fieldName',
      value : data.value
    };
    this.fieldTree.searchData = searchData;
    // this.fieldTree.searchData.field = 'fieldName';
    let serchFields = {
      label : this.localePipe.transform('component.executeForms.fieldName'),
      value : 'fieldName'
    };
    if(this.fieldTree.searchFields) {
      if(!this.fieldTree.searchFields.some(x => x.value === serchFields.value)) {
        this.fieldTree.searchFields = this.fieldTree.searchFields.concat(serchFields);
      }
    }else {
      this.fieldTree.searchFields = [];
      this.fieldTree.searchFields = this.fieldTree.searchFields.concat(serchFields);
    }
    this.fieldTree.searchHandle.search(data.field, data.value, 'client');
  }

  btnConfigChange(bool: boolean, field: string, id: string) {
    if (bool) {
      for (const b of this.buttonConfigs) {
        if (b.id === id) {
          switch (field) {
            case 'enable':
              b.enable = bool;
              b.disabled = false;
              b.hidden = false;
              break;
            case 'disabled':
              b.disabled = bool;
              b.enable = false;
              b.hidden = false;
              break;
            case 'hidden':
              b.hidden = bool;
              b.disabled = false;
              b.enable = false;
              break;
          }
          this.btnGrid.updateRow(id, b);
        }
      }
    }
    this.btnGrid.cd.detectChanges();
  }

  btnBatchOperate(operation: string) {
    const checkeds = this.btnGrid.checkedRows;
    if (checkeds && checkeds.length > 0) {
      for (const c of checkeds) {
        if(!c.data.configurableStates || (c.data.configurableStates.length > 0 && this.isHasBtn(operation, c.data.configurableStates))) {
          this.btnConfigChange(true, operation, c.id);
        }
      }
      this.btnGrid.cd.detectChanges();
    } else {
      this.message.info(this.localePipe.transform('component.executeForms.checkedRows'))
    }
  }

  btnBatchReset() {
    const checkeds = this.btnGrid.checkedRows;
    if (checkeds && checkeds.length > 0) {
      for (const c of checkeds) {
        const button = this.formFormat.formButtons.find(b => b.id === c.id);
        for (const b of this.buttonConfigs) {
          if (b.id === c.id) {
            b.enable = button.buttonState === 'Enable' ? true : false;
            b.disabled = button.buttonState === 'Disabled' ? true : false;
            b.hidden = button.buttonState === 'Hidden' ? true : false;
          }
          this.btnGrid.updateRow(b.id, b);
        }
      }
      this.btnGrid.cd.detectChanges();
    } else {
      this.message.info(this.localePipe.transform('component.executeForms.checkedRows'))
    }
  }

  fieldConfigChange(bool: boolean, field: string, id: string, search=true) {
    if (bool) {
      this.fieldSwitchChange(this.fieldConfigs, field, id);
      if(field === 'required') {
        if(!this.operationConfig.operations) {
          if(this.operationConfig.formMethods) {
            this.operationConfig.formMethods.forEach(data => {
              if(data.method === 'wf-required-verification') {
                const operation = new FormMethodConfig();
                operation.formFormatConfigId = this.config.id;
                operation.method = data.method;
                operation.sortOrder = data.sortOrder;
                operation.methodParameters = data.methodParameters;
                this.operationConfig.operations = [];
                this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
              }
            });
          }
        } else if(!this.operationConfig.operations.some(formMethod => formMethod.method === 'wf-required-verification')) {
          if(this.operationConfig.formMethods) {
            this.operationConfig.formMethods.forEach(data => {
              if(data.method === 'wf-required-verification') {
                const operation = new FormMethodConfig();
                operation.formFormatConfigId = this.config.id;
                operation.method = data.method;
                operation.sortOrder = data.sortOrder;
                operation.methodParameters = data.methodParameters;
                this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
              }
            });
          }
        }
      }
    } 
    if (search) {
      this.fieldTree.searchHandle['research']();
    }
    setTimeout(() => {
      if(!bool){
        if(!this.hasRequired(this.fieldConfigs)) {
          if(this.operationConfig.operations) {
            this.operationConfig.operations = this.operationConfig.operations.filter(formMethod => formMethod.method != 'wf-required-verification');
          }
        }
      }
    },100);
  }
  private fieldSwitchChange(fieldConfigs: Array<any>, field: string, id: string) {
    if (fieldConfigs.length > 0) {
      for (const f of fieldConfigs) {
        if (f.data.id === id) {
          switch (field) {
            case 'editable':
              f.data.editable = true;
              f.data.readonly = false;
              f.data.hidden = false;
              f.data.required = false;
              break;
            case 'readonly':
              f.data.editable = false;
              f.data.readonly = true;
              f.data.hidden = false;
              f.data.required = false;
              break;
            case 'hidden':
              f.data.editable = false;
              f.data.readonly = false;
              f.data.hidden = true;
              f.data.required = false;
              break;
            case 'required':
              f.data.editable = false;
              f.data.readonly = false;
              f.data.hidden = false;
              f.data.required = true;
              break;
          }
          return;
        } else {
          if (f.children && f.children.length > 0) {
            this.fieldSwitchChange(f.children, field, id);
          }
        }
      }
    }
  }

  fieldBatchOperate(operation: string) {
    const checkeds = this.fieldTree.checkeds;
    if (checkeds && checkeds.length > 0) {
      for (const c of checkeds) {
        if(!c.data.configurableStates || (c.data.configurableStates.length > 0 && this.isHasField(operation, c.data.configurableStates))) {
          this.fieldConfigChange(true, operation, c.data.id, false);
        }
      }
      this.fieldTree.searchHandle['research']();
    } else {
      this.message.info(this.localePipe.transform('component.executeForms.checkeds'))
    }
  }

  fieldBatchReset() {
    const checkeds = this.fieldTree.checkeds;
    if (checkeds && checkeds.length > 0) {
      for (const c of checkeds) {
        const field = this.formatFieldList.find(f => f.id === c.data.id);
        this.resetFieldConfig(this.fieldConfigs, c.data.id, field);
      }
      this.fieldTree.searchHandle['research']();
    } else {
      this.message.info(this.localePipe.transform('component.executeForms.checkeds'))
    }
    if(this.hasRequired(this.fieldConfigs)) {
      if(!this.operationConfig.operations) {
        if(this.operationConfig.formMethods) {
          this.operationConfig.formMethods.forEach(data => {
            if(data.method === 'wf-required-verification') {
              const operation = new FormMethodConfig();
              operation.formFormatConfigId = this.config.id;
              operation.method = data.method;
              operation.sortOrder = data.sortOrder;
              operation.methodParameters = data.methodParameters;
              this.operationConfig.operations = [];
              this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
            }
          });
        }
      } else if(!this.operationConfig.operations.some(formMethod => formMethod.method === 'wf-required-verification')) {
        if(this.operationConfig.formMethods) {
          this.operationConfig.formMethods.forEach(data => {
            if(data.method === 'wf-required-verification') {
              const operation = new FormMethodConfig();
              operation.formFormatConfigId = this.config.id;
              operation.method = data.method;
              operation.sortOrder = data.sortOrder;
              operation.methodParameters = data.methodParameters;
              this.operationConfig.operations = this.operationConfig.operations.concat([operation]);
            }
          });
        }
      }
    }else {
        if(this.operationConfig.operations) {
          this.operationConfig.operations = this.operationConfig.operations.filter(formMethod => formMethod.method != 'wf-required-verification');
        }
    }
  }
  resetFieldConfig(fieldConfigs: Array<any>, id: string, field: FormField) {
    if (fieldConfigs.length > 0) {
      for (const f of fieldConfigs) {
        if (f.leaf === true && f.data.id === id) {
          f.data.editable = field.fieldState === 'Editable' ? true : false;
          f.data.readonly = field.fieldState === 'Readonly' ? true : false;
          f.data.hidden = field.fieldState === 'Hidden' ? true : false;
          f.data.required = field.fieldState === 'Required' ? true : false;
          return;
        } else {
          if (f.children && f.children.length > 0) {
            this.resetFieldConfig(f.children, id, field);
          }
        }
      }
    }
  }

  private validator(): Observable<boolean> {
    if (this.extendComponentRef) {
      const result$ = this.extendComponentRef.instance.validator();
      if (result$ instanceof Observable) {
        return result$.pipe(
          switchMap((b: boolean) => {
            if (b && this.innerValidator()) {
              return of(true);
            } else {
              return of(false);
            }
          }));
      } else {
        if (result$) {
          return of(this.innerValidator());
        } else {
          return of(false);
        }
      }
    } else {
      return of(this.innerValidator());
    }
  }

  private innerValidator(): boolean  {
    return this.operationConfig.validator();
  }


  private setBtnAndFieldConfigs() {
    this.config.formButtonConfigs = new Array<FormButtonConfig>();
    for (const btn of this.buttonConfigs) {
      const button = this.formFormat.formButtons.find(b => b.buttonId === btn.buttonId);
      const btnConfig = new FormButtonConfig();
      btnConfig.buttonId = btn.buttonId;
      if (btn.enable) {
        btnConfig.buttonState = 'Enable';
      } else if (btn.disabled) {
        btnConfig.buttonState = 'Disabled';
      } else if (btn.hidden) {
        btnConfig.buttonState = 'Hidden';
      } else {
        continue;
      }
      if (!button.buttonState && btnConfig.buttonState) {
        this.config.formButtonConfigs.push(btnConfig);
      }
      if (button.buttonState && button.buttonState !== btnConfig.buttonState) {
        this.config.formButtonConfigs.push(btnConfig);
      }
    }
    this.config.formFieldConfigs = new Array<FormFieldConfig>();
    this.getFieldConfigs(this.fieldConfigs);

    this.config.formMethodConfigs = this.operationConfig.operations || new Array();
  }

  private getFieldConfigs(fieldConfigs: Array<any>) {
    if (fieldConfigs && fieldConfigs.length > 0) {
      for (const f of fieldConfigs) {
        if (f.children && f.children.length > 0) {
          this.getFieldConfigs(f.children);
        }
        if (f.leaf === false) {
          continue;
        }
        const field = this.formatFieldList.find(fd => fd.fieldId === f.data.fieldId);
        const fieldConfig = new FormFieldConfig();
        fieldConfig.fieldId = f.data.fieldId;
        if (f.data.editable) {
          fieldConfig.fieldState = 'Editable';
        } else if (f.data.readonly) {
          fieldConfig.fieldState = 'Readonly';
        } else if (f.data.hidden) {
          fieldConfig.fieldState = 'Hidden';
        } else if (f.data.required) {
          fieldConfig.fieldState = 'Required';
        } else {
          continue;
        }

        if (!field.fieldState && fieldConfig.fieldState) {
          this.config.formFieldConfigs.push(fieldConfig);
        }

        if (field.fieldState && field.fieldState !== fieldConfig.fieldState) {
          this.config.formFieldConfigs.push(fieldConfig);
        }
      }
    }
  }

  private getConfig() :Observable<any>{
    let subject = new Subject<any>();
    if (this.formFormatId) {
      forkJoin(this.getFormFormatType(), this.getFormFormat(), this.getFormFormatConfig()).subscribe((re: any[]) => {
        const formFormatType = re[0] as FormFormatType;
        if (formFormatType) {
          this.formFormatType = formFormatType;
          if (this.formFormatType.extendImpl) {
            this.showExtendTab = true;
            this.createExtendComponent(this.formFormatType.extendImpl);
          } else {
            this.showExtendTab = false;
          }
        }
        const formFormat = re[1] as FormFormat;
        if (formFormat) {
          this.formFormat = this.convertFormFormat(formFormat);
        }
        const config = re[2] as FormFormatConfig;
        if (config) {
          this.config = config;
        }
        if (this.formFormat.formButtons) {
          this.buttonConfigs = this.formFormat.formButtons.map(b => Object.assign({}, b, {
            enable: b.buttonState === 'Enable' ? true : false,
            disabled: b.buttonState === 'Disabled' ? true : false,
            hidden: b.buttonState === 'Hidden' ? true : false
          }));
          let btnConfigs = new Array<FormButtonConfig>();
          if (config && config.formButtonConfigs) {
            btnConfigs = config.formButtonConfigs;
          }
          for (const b of btnConfigs) {
            for (const btn of this.buttonConfigs) {
              if (btn.buttonId === b.buttonId) {
                switch (b.buttonState) {
                  case 'Enable':
                    btn.enable = true;
                    btn.disabled = false;
                    btn.hidden = false;
                    break;
                  case 'Disabled':
                    btn.enable = false;
                    btn.disabled = true;
                    btn.hidden = false;
                    break;
                  case 'Hidden':
                    btn.enable = false;
                    btn.disabled = false;
                    btn.hidden = true;
                    break;
                }
                break;
              }
            }
          }
        }
        if (this.formFormat.formFields) {
          this.fieldConfigs = [...this.formFormat.formFields];
          this.orgFieldConfigs(this.fieldConfigs);
          let configs = new Array<FormFieldConfig>();
          if (config && config.formFieldConfigs) {
            configs = config.formFieldConfigs;
          }
          for (const f of configs) {
            this.setFieldConfig(this.fieldConfigs, f);
          }
        }
        this.loaded.next(this.formFormat);
        subject.next(this.config);
      });
    }
    return subject.asObservable();
  }

  createExtendComponent(extendImpl: string) {
    const url = extendImpl.split('#')[0];
    const selectorCmp = extendImpl.split('#')[1];
    System.import(url)
      .then((moduleFactorys: any) => {
        const moduleFactory: any = Object.values(moduleFactorys)[0];
        const moduleRef = moduleFactory.create(this.injector);
        if (selectorCmp) {
          let facMap: Map<any, any> = moduleRef.componentFactoryResolver['_factories'];
          facMap.forEach((value: any, key: Function, map: Map<any, any>) => {
              const selector = value.selector;
              if (selectorCmp == selector) {
                const cmpFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(key as any);
                this.extendComponentRef = cmpFactory.create(moduleRef.injector);
                this.extendComponentRef.instance.formFormatId = this.formFormatId;
                this.extendComponentRef.instance.formatConfigId = this.formatConfigId;
                this.extendComponentRef.instance.params = this.formFormat.urlParameters;//表单格式的url parameters
                this.extendComponentRef.instance.extendParameters = this.formFormat.extendParameters;//表单格式扩展的parameters
                if(this.config && this.config.formExtendConfigs){
                  this.extendComponentRef.instance.formExtendConfigs = this.config.formExtendConfigs;//表单格式其他的存储结果
                }
                this.container.clear();
                this.container.insert(this.extendComponentRef.hostView);
              }
          });
        } else {
          const bootstrapComponent = moduleRef['_bootstrapComponents'][0];
          if (bootstrapComponent)//先找bootstrapComponent数组有无组件
          {
            const cmpFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(bootstrapComponent);
            this.extendComponentRef = cmpFactory.create(moduleRef.injector);
            this.extendComponentRef.instance.formFormatId = this.formFormatId;
            this.extendComponentRef.instance.formatConfigId = this.formatConfigId;
            this.extendComponentRef.instance.params = this.formFormat.urlParameters;//表单格式的url parameters
            this.extendComponentRef.instance.extendParameters = this.formFormat.extendParameters;//表单格式扩展的parameters
            if(this.config && this.config.formExtendConfigs){
              this.extendComponentRef.instance.formExtendConfigs = this.config.formExtendConfigs;//表单格式其他的存储结果
            }   
            this.container.clear();
            this.container.insert(this.extendComponentRef.hostView);
          }
        }
    });
  }

  private orgFieldConfigs(formFields: Array<FormFieldData>) {
    if (formFields.length > 0) {
      for (const d of formFields) {
        d.data = Object.assign({}, d.data, {
          editable: d.data.fieldState === 'Editable' ? true : false,
          readonly: d.data.fieldState === 'Readonly' ? true : false,
          hidden: d.data.fieldState === 'Hidden' ? true : false,
          required: d.data.fieldState === 'Required' ? true : false
        });
        if (d.children && d.children) {
          this.orgFieldConfigs(d.children);
        }
      }
    }
  }

  private setFieldConfig(fieldConfigs: Array<any>, config: FormFieldConfig) {
    if (fieldConfigs.length > 0) {
      for (const f of fieldConfigs) {
        if (f.data.fieldId === config.fieldId) {
          switch (config.fieldState) {
            case 'Editable':
              f.data.editable = true;
              f.data.readonly = false;
              f.data.hidden = false;
              f.data.required = false;
              break;
            case 'Readonly':
              f.data.editable = false;
              f.data.readonly = true;
              f.data.hidden = false;
              f.data.required = false;
              break;
            case 'Hidden':
              f.data.editable = false;
              f.data.readonly = false;
              f.data.hidden = true;
              f.data.required = false;
              break;
            case 'Required':
              f.data.editable = false;
              f.data.readonly = false;
              f.data.hidden = false;
              f.data.required = true;
              break;
          }
          return;
        } else {
          if (f.children && f.children.length > 0) {
            this.setFieldConfig(f.children, config);
          }
        }
      }
    }
  }

  private saveConfig(config: FormFormatConfig): Observable<any> {
    const url = '/api/runtime/wf/v1.0/formFormatConfig';
    return this.http.post(url, config);
  }

  private getFormFormat(): Observable<any> {
    if (this.formFormatId) {
      let url = `/api/runtime/wf/v1.0/formFormat/${this.formFormatId}`;
      url = encodeURI(url);
      return this.http.get(url);
    } else {
      return of(null);
    }
  }

  private getFormFormatType(): Observable<any> {
    if (this.formFormatId) {
      const url = `/api/runtime/wf/v1.0/formFormatType/formFormat?formFormat=${this.formFormatId}`;
      return this.http.get(url);
    }
  }

  private getFormFormatConfig(): Observable<any> {
    if (this.formatConfigId) {
      let url = `/api/runtime/wf/v1.0/formFormatConfig/${this.formatConfigId}`;
      url = encodeURI(url);
      return this.http.get(url);
    } else {
      return of(null);
    }
  }

  private convertFormFormat(formFormat: FormFormat): FormFormat {
    if (!formFormat.status) {
      formFormat.status = 0;
    }
    this.convertformFields(formFormat.formFields);
    this.getFormatFieldList(formFormat.formFields, this.formatFieldList);
    return formFormat;
  }

  private convertformFields(formFields: Array<FormFieldData>) {
    if (formFields && formFields.length > 0) {
      for (const d of formFields) {
        if (typeof(d.leaf) !== 'boolean' && (d.leaf == null || d.leaf === undefined)) {
          d.leaf = true;
        }
        if (d.children && d.children) {
          this.orgFieldConfigs(d.children);
        }
      }
    }
  }

  private getFormatFieldList(formFields: Array<FormFieldData>, array: Array<FormField>) {
    if (formFields && formFields.length > 0) {
      for (const d of formFields) {
        array.push(d.data);
        if (d.children && d.children) {
          this.getFormatFieldList(d.children, array);
        }
      }
    }
  }

  private getFormatField(formFields: Array<FormFieldData>, fieldId: string): FormFieldData {
    for (const f of formFields) {
      if (f.data.fieldId === fieldId) {
        return f;
      }
      if (f.children && f.children.length > 0) {
        return this.getFormatField(f.children, fieldId);
      }
    }

  }

  public hasRequired(fieldConfigs: Array<any>): boolean {
    if (fieldConfigs && fieldConfigs.length > 0) {
      for (const f of fieldConfigs) {
        if(f.data.required == true) {
          return true;
        }else {
          if (f.children && f.children.length > 0) {
            if(this.hasRequired(f.children)) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  private getFormMethods() :Observable<any>{
    let subject = new Subject<any>();
    if (this.formFormatId) {
      const url = `/api/runtime/wf/v1.0/formOperation?formFormatId=${this.formFormatId}`;
      this.http.get(url).subscribe((re: any) => {
        if (re) {
          this.operationConfig.formMethods = re;
        }
        subject.next(re);
      });
    }
    return subject.asObservable();
  }

  public isHasField(field, configurableStates:[]) {
    if(configurableStates) {
      switch (field) {
        case 'editable':
          if(configurableStates.find(state => state === ('Editable'))) {
            return true;
          }
          break;
        case 'readonly':
          if(configurableStates.find(state => state === ('Readonly'))) {
            return true;
          }
          break;
        case 'hidden':
          if(configurableStates.find(state => state === ('Hidden'))) {
            return true;
          }
          break;
        case 'required':
          if(configurableStates.find(state => state === ('Required'))) {
            return true;
          }
          break;
      }
    }
    return false;
  }

  public isHasBtn(btn, configurableStates) {
    if(configurableStates) {
      switch (btn) {
        case 'enable':
          if(configurableStates.find(state => state === ('Enable'))) {
            return true;
          }
          break;
        case 'disabled':
          if(configurableStates.find(state => state === ('Disabled'))) {
            return true;
          }
          break;
        case 'hidden':
          if(configurableStates.find(state => state === ('Hidden'))) {
            return true;
          }
          break;
      }
    }
    return false;
  }

}
